goog.provide('el8.ptdata.model.note.checkout');

goog.require('el8.ptdata.patients');
goog.require('el8.data.referencedUsers');
goog.require('el8.data.staffGroups');
goog.require('el8.model.base');
goog.require('el8.service.tz');

(function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addIntProperty('physicianId');
    _class.addIntProperty('staffUserId');
    _class.addIntProperty('staffGroupId');
    _class.addDateTime('createDate', false, el8.service.tz.now());
    _class.addDateTime('addressDate');
    _class.addDate('apptByDate');
    _class.addStringProperty('followUp');
    _class.addStringProperty('testNotifications');
    _class.addStringProperty('followUpInstructions');
    _class.addBoolean('complete');
    _class.addStringProperty('reason');
    _class.addIntProperty('threadId');
    _class.addIntProperty('apptId');
    _class.addIntProperty('patientId');
    _class.addStringProperty('patientName');

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        spec['model_class'] = 'Checkout';
        this.parent.populate.call(this, spec);
    };

    _class.prototype.getReceiverName = function() {
        if (this.getStaffUserId()) {
            return el8.data.referencedUsers.getById(this.getStaffUserId()).getFullName();
        } else {
            return el8.data.staffGroups.getById(this.getStaffGroupId()).getName();
        }
    };

    _class.prototype.getSummary = function() {
        var str = 'Checkout sent to ' + this.getReceiverName() + '. ';
        if (this.getFollowUpInstructions()) {
            str += 'Instructions: ' + this.getFollowUpInstructions();
        }
        return str;
    };

    el8.ptdata.model.note.checkout = function(spec) { return new _class(spec); };

})();

